<template>
  <div v-if="isShow" class="compass" :class="{mobile : isMobile,'top-indent':!isMobile && isFromIndexMap}" >
    <img class="plate" src="@/assets/images/compass_plate.png" alt="">
<!--    <img class="ring" src="@/assets/images/compass_ring.png" alt="">-->
    <img :style="{transform:`translate(-50%,-50%) rotate(${pointerRotate}deg)`}" class="pointer" src="@/assets/images/compass_pointer.png" alt="">
  </div>
</template>

<script>
	import { mapState } from "vuex";
  export default {
    data(){
      return{
				pointerRotate:0
      }
    },

		computed: {
			...mapState("preview", [
				"krp",
				"materialId",
				"sceneList",
        "isFromIndexMap"
			]),
			sceneData() {
				let sceneList = this.sceneList;
				return Array.isArray(sceneList)
					? sceneList.find((item) => this.materialId == item.id)
					: {};
			},
      isShow(){
				if(this.sceneData && this.sceneData.info){
					if(this.sceneData.info.dir !== ''){
            if(!isNaN(this.sceneData.info.dir)){
							return typeof Number(this.sceneData.info.dir) === "number"
            }

          }
        }
				return false
      },
		},

    created() {
      window.krpjs.onViewChange = this.onViewChange
    },

    methods:{
			onViewChange(hlookat){
				if(this.isShow){
					// console.log(this.sceneData.name,this.sceneData.info.hlookat[1],this.sceneData.info.dir,this.pointerRotate)
					// console.log(this.sceneData.info.hlookat[1],this.sceneData.info.dir)
          let initHlookat = Number(this.sceneData.info.hlookat[1]);
					initHlookat = initHlookat >= 0 ? initHlookat : 360 + initHlookat;
					hlookat = Number(hlookat)
					hlookat =  hlookat >= 0 ? hlookat : 360 + hlookat;
					this.pointerRotate =(initHlookat - this.sceneData.info.dir) + (hlookat - initHlookat);
        }
      }
    }
	}

</script>

<style scoped>
  .compass{
    width: 90px;
    height: 90px;
    position: absolute;
    top:5px;
    right: 80px;
    transform-origin: top left;
  }

  .compass.mobile{
    transform: scale(0.7) translate(-50%);
    right: initial;
    left:50%;
  }

  .compass.top-indent{
    top:55px;
  }

  .compass .plate,.compass .ring{
    position: absolute;
    display: block;
    left:0;
    top:0;
  }

  .compass .plate{
    position: absolute;
    display: block;
    left:50%;
    top:50%;
    height: 84px;
    transform: translate(-50%,-50%);
  }

  .compass .plate{
    transform-origin: center center;
  }

  .compass .pointer{
    position: absolute;
    display: block;
    left:50%;
    top:50%;
    height: 50px;
  }
</style>
